import React from 'react'

import { Box, Card, Checkbox, FormControlLabel, Grid, Typography } from '@mui/material'
import { convertToPersianNumber } from 'utils'

export const Filters = () => {

    const coursesType = [
        { title: 'رایگان', activeCoursesCount: 36, id: 2, checked: true },
        { title: 'فقط نقدی', activeCoursesCount: 36, id: 2, checked: true },
    ]
    const categories = [
        { title: 'اسپلانک', activeCoursesCount: 36, id: 1, checked: true },
        { title: 'آگهی رسانی امنیت', activeCoursesCount: 20, id: 2, checked: true },
        { title: 'ویندوز و لینوکس', activeCoursesCount: 15, id: 3, checked: true },
        { title: 'هک و نفوذ', activeCoursesCount: 4, id: 4, checked: true },
        { title: 'مجازی سازی', activeCoursesCount: 4, id: 4, checked: true },
    ]

    const CourseFilterItem = ({ title, activeCoursesCount, id, checked, onChecked, ...props }) => {
        return <Box sx={{ mx: 1, my: 0.25, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>

                <FormControlLabel
                    label={<Typography color='#505050' fontSize={15}>{title}</Typography>}
                    control={<Checkbox checked={checked} onChange={({ target: { checked } }) => onChecked(checked)} />}
                />
            </Box>
            <Typography fontSize={15} color='#89939F'>{convertToPersianNumber(activeCoursesCount)} دوره</Typography>
        </Box>
    }

    return (
        <>
            <Grid item xs={12}>
                <Card sx={{ p: 1 }}>
                    <Typography fontSize={16} sx={{ m: 1 }} fontWeight={700}>نوع دوره</Typography>
                    {coursesType.map(type => <CourseFilterItem {...type} />)}
                </Card>

            </Grid>
            <Grid item xs={12} >
                <Card sx={{ p: 1 }}>
                    <Typography fontSize={16} sx={{ m: 1 }} fontWeight={700}>دسته بندی</Typography>
                    {categories.map(type => <CourseFilterItem {...type} />)}
                </Card>
            </Grid>
        </>

    )
}
